export enum SettingsCategory {
  CL_PAYMENTS_PAGE = "CL_PAYMENTS_PAGE",
  CL_CARDS_PAGE = "CL_CARDS_PAGE",
  CL_HELP_PAGE = "CL_HELP_PAGE",
  CL_ACCOUNT_STATEMENTS = "CL_ACCOUNT_STATEMENTS",
  CL_REGISTRATION = "CL_REGISTRATION",
  CL_WITHDRAWAL = "CL_WITHDRAWAL",
  CL_FAQ_SETTINGS = "CL_FAQ_SETTINGS",
}
